const HOVER_SUFFIX = ':hover';
export default {
    getDefaultId: (id) => id?.replace(HOVER_SUFFIX, ''),
};
//# sourceMappingURL=utils.js.map